import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { storageSet, storageGet } from '../../../Libs/Collector/StorageAction';
import { cookieGet } from "../../../Libs/Collector/CookieAction";
import api from "../../../Libs/Api/AxiosConfig";



export const getLogin = createAsyncThunk(
    'Login/getLogin',
    async (data) => {

        const apiData = {
            email: data.email,
            password: data.password,
            pin: data.pin,
            reCaptcha: data.reCaptcha,
            clientId: storageGet("clientId"),
            activityId: storageGet("activityId"),
            csrf: cookieGet("csrf")
        }


     
        const res = await api.post(`/User/Login`, apiData);
        return res.data;
    })


export const LoginSlice = createSlice({
    name: 'Login',
    initialState: {
        loading: false,
        error: false,
        status: 1,
        auth: false,
        modules: [],
        reason: "",
        requestCount: 0


    },
    reducers: {
        SetLoading: (state) => {
            state.loading = true;

        },
        ClearErrorReducer: (state) => {
            state.auth = false;
            state.error = false;
            state.reason = "";

        },
        LogoutReducer: (state) => {

            state.loading = false;
            state.auth = false;
            localStorage.removeItem("token");
            localStorage.removeItem("refreshToken");
            state.reason = "";

        },
        RefershLoginReducer: (state, action) => {
            state.loading = false;
            state.auth = true;
            state.reason = "";
            storageSet("token", action.payload.data.token);
        },

    },
    extraReducers: (builder) => {

        builder.addCase(getLogin.pending, (state, { payload }) => {
            state.loading = true;
            
        })

        builder.addCase(getLogin.fulfilled, (state, { payload }) => {
            state.loading = false;
            window.grecaptcha.reset();
            if (payload.payload.status) {

                const { token, refreshToken } = payload.payload;
                state.auth = true;
                storageSet("token", token);
                storageSet("refreshToken", refreshToken);
                state.reason = "";
                state.requestCount = 0

            } else {
                state.requestCount = 1
                state.auth = false;
                state.error = true;
                state.reason = payload.payload.reason;
            }
        })

        builder.addCase(getLogin.rejected, (state, { payload }) => {
            state.loading = false;
            state.error = true;
            state.reason = "";
        })

    }
})

export const { LogoutReducer, RefershLoginReducer, ClearErrorReducer, SetLoading } = LoginSlice.actions;



export const LoginReducer = LoginSlice.reducer